module.exports = __webpack_public_path__ + "static/AI-analytics-b658a0b67b9e78c6f38158e76e4b95aa.png";